export default class InstallationCharges {
  constructor({
    id = 0,
    orderId = 0,
    service = 0,
    quantity = 1,
    amount = 0,
    itemDetails = null,
    cost = 0,
    discount = 0,
    totalCost = 0,
    isFreeType = false,
    recurringChargeID = 0,
    recurringChargeFrequency = null,
    paymentType = 'once',
    contractLength = 0,
    csn = '',
  } = {}) {
    this.id = id;
    this.orderId = orderId;
    this.service = parseInt(service);
    this.quantity = quantity;
    this.amount = amount;
    this.itemDetails = isFreeType ? itemDetails : parseInt(itemDetails);
    this.cost = cost;
    this.discount = discount;
    this.totalCost = totalCost;
    this.isFreeType = isFreeType;
    this.recurringChargeID = recurringChargeID;
    this.recurringChargeFrequency = recurringChargeFrequency;
    this.paymentType = paymentType;
    this.contractLength = contractLength;
    this.csn = csn;
  }
}
